// extracted by mini-css-extract-plugin
export default {"tabContainer":"popupRecommendationList_tabContainer__AYXe9","tabs":"popupRecommendationList_tabs__cK34y","tabItem":"popupRecommendationList_tabItem__u5k+1"};